export default __webpack_public_path__ + "static/tools-romax-4000-ae78a723bd733b0c634c0e2982af9829.jpg";